import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'

import 'element-ui/packages/theme-chalk/src/index.scss'
// import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import 'element-ui/lib/theme-chalk/display.css'
import '@/assets/fonts/iconfont/iconfont.css'
import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import '@/router/permission' // permission control

// 移动端支持拖动
import '@/utils/DragDropTouch.js'

// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI, {
//   // size: 'small'
// })

if (process.env.NODE_ENV === 'production') {
  // console.log = () => {}
}

Vue.config.productionTip = false

Vue.config.errorHandler = function(err, vm, info) {
  console.warn(err, vm, info)
}

// window.onerror = function(msg, url, line, col, error) {
//   // code to handle or report error goes here
//   console.log(msg, url, line, col, error)
// }

// 处理axios中抛出的后端返回错误
window.addEventListener('unhandledrejection', function(event) {
  // handle error here
  // event.promise contains the promise object
  // event.reason contains the reason for the rejection
  event.preventDefault()
  if (event?.reason?.message?.startsWith('Redirected when going from')) {
    // If pushing interrupted because of redirection from navigation guard - ignore it.
    // https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
    return
  }
  console.warn(event)
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
